import { Component, Type, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgComponentOutlet } from '@angular/common';
import { MatFormField, MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { DialogResult } from './dialog-result';

export { DialogResult };
import { AddListComponent } from '../list.add';

@Component({
    selector: 'popup-dialog',
    styleUrls: ['./popup.dialog.scss'],
    templateUrl: './popup.dialog.html',
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatFormField, MatInput, FormsModule, MatSelect, MatOption, MatButton, MatCheckbox, AddListComponent, NgComponentOutlet]
})
export class PopupDialog implements OnInit {
    listEditorComponent: Type<any> | null = null;
    listEditorInputs: any = {};
    public DialogTitle: string;
    public DialogDescription: string;
    public DialogDescriptionHTML: string;
    public DialogConfirmButtonText: string;
    public DialogCancelButtonText: string;
    public DisplayTextBox: boolean;
    public DisplayOptionClear: boolean = true;
    public DialogTextBox: string;
    public DialogTextBoxMaxLength = 1024;
    public DialogCodeArea: string;
    public DisplayCodeArea: boolean;
    public DisplayListEditor: boolean;
    public DisplayListAdd: boolean;
    public DisplayTextArea: boolean;
    public DisplayTextAreaLength: number;
    public DialogTextArea = '';
    public DialogPlaceholderTextArea: string;
    public DialogOptions: string[];
    public DialogSelectedOption: string;
    public DialogListAlias: string;
    public DialogPlaceHolder = 'Release Notes';
    private displayCheckbox = false;
    public DialogCheckboxLabel: string;
    public DialogCheckboxChecked: boolean = false;

    public set DisplayCheckbox(value: boolean) {
        this.displayCheckbox = value;
    }

    public get DisplayCheckbox(): boolean {
        return this.displayCheckbox && !!(this.DialogTextBox || this.DialogSelectedOption);
    }
    private dialogResult: DialogResult = new DialogResult();

    public constructor(public dialogRef: MatDialogRef<PopupDialog, DialogResult>) { }

    async ngOnInit() {  
        if (this.DisplayListEditor) {
            const { ListEditorComponent } = await import('../list.editor');
            this.listEditorComponent = ListEditorComponent;
            this.listEditorInputs = { listAlias: this.DialogListAlias };
        }
    }

    public closeDialog(result: boolean): void {
        this.dialogResult.Result = result;
        this.dialogResult.Text = this.DialogTextBox || this.DialogCodeArea || this.DialogSelectedOption || this.DialogTextArea;
        if (this.DisplayCheckbox) {
            this.dialogResult.Payload = { applyEvenWhenHidden: this.DialogCheckboxChecked };
        }
        this.dialogRef.close(this.dialogResult);
    }

    public clearSelection(): void {
        this.dialogResult.Result = true;
        this.dialogResult.Payload = { clearSelection: true };
        this.dialogRef.close(this.dialogResult);
    }
}
